<div
  (keyup.space)="this.toggle.emit(); $event.preventDefault()"
  (keydown.enter)="this.toggle.emit(); $event.preventDefault()"
  [class]="'switch' + (extraClasses ? ' ' + extraClasses : '')"
  [class.small]="small"
  (click)="this.toggle.emit()"
  tabindex="0"
  role="switch"
  [attr.aria-checked]="active"
  [attr.aria-label]="label || 'Toggle switch'"
>
  @if (label && !labelToRight) {
    <div class="switch__label" id="switch-label">{{ label }}</div>
  }
  <div class="switch__track" data-cy="myp-switch" [style.backgroundColor]="active ? activeTrackColor : '#999'" aria-hidden="true">
    <div class="switch__handle" [class.active]="active"></div>
  </div>
  @if (label && labelToRight) {
    <div class="switch__label m-l-10" id="switch-label-right">
      {{ label }}
      @if (sublabel) {
        <br />
        <span class="t-12 text-muted">{{ sublabel }}</span>
      }
    </div>
  }
</div>
